<template>
  <section class="container py-4 col-12 col-lg-10 suporte-page" id="container">
    <div class="suporte-header page-header mb-md-5">
      <p class="suporte-eyebrow page-header-eyebrow">SUPORTE</p>
      <h1 class="page-title mb-1">Entrar em contato</h1>
      <p class="page-subtitle mb-0">
        Estamos disponíveis para ajudar com dúvidas sobre a WiseCalc.
      </p>
    </div>

    <div class="suporte-options">
      <article class="suporte-option suporte-option--whatsapp">
        <div class="suporte-option__icon" aria-hidden="true">
          <i class="ti ti-brand-whatsapp"></i>
        </div>
        <div class="suporte-option__content">
          <h2>WhatsApp</h2>
          <p>Converse diretamente com nossa equipe de suporte.</p>
          <a
            class="suporte-option__button"
            href="https://wa.me/557181446868?text=Ol%C3%A1%2C%20preciso%20de%20ajuda%20com%20a%20WiseCalc."
            target="_blank"
            rel="noopener noreferrer"
          >
            <i class="ti ti-brand-whatsapp" aria-hidden="true"></i>
            Abrir WhatsApp
          </a>
          <span class="suporte-option__detail">+55 71 8144-6868</span>
        </div>
      </article>

      <article class="suporte-option suporte-option--email">
        <div class="suporte-option__icon" aria-hidden="true">
          <i class="ti ti-mail"></i>
        </div>
        <div class="suporte-option__content">
          <h2>E-mail</h2>
          <p>Envie sua dúvida e retornaremos assim que possível.</p>
          <a class="suporte-option__email" href="mailto:wisecalcsuporte@gmail.com">
            wisecalcsuporte@gmail.com
          </a>
        </div>
      </article>
    </div>
  </section>
</template>

<script>
export default {
  name: "Suporte",
  mounted() {
    this.ajustarTamanhoCardPrincipal();
  },
  methods: {
    ajustarTamanhoCardPrincipal() {
      const card = document.querySelector(".card-principal");
      if (card) {
        card.style.maxWidth = "1200px";
      }
    },
  },
};
</script>

<style scoped>
.suporte-page {
  margin: 0 auto;
  padding: 8px 0 32px;
}

.suporte-eyebrow {
  margin: 0 0 8px;
  color: #0056ff;
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.suporte-header h1 {
  margin: 0;
  color: #172033;
  font-size: clamp(1.65rem, 3vw, 2.25rem);
  font-weight: 800;
}

.suporte-intro {
  margin: 10px 0 0;
  color: #596579;
  font-size: 0.95rem;
}

.suporte-options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
  margin-top: 32px;
}

.suporte-option {
  display: flex;
  gap: 16px;
  min-height: 220px;
  padding: 24px;
  border: 1px solid #d8dee9;
  border-radius: 8px;
  background: #ffffff;
}

.suporte-option--whatsapp {
  border-top: 4px solid #087f5b;
}

.suporte-option--email {
  border-top: 4px solid #0056ff;
}

.suporte-option__icon {
  display: inline-flex;
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 1.5rem;
}

.suporte-option--whatsapp .suporte-option__icon {
  color: #087f5b;
  background: #e6f7f0;
}

.suporte-option--email .suporte-option__icon {
  color: #0056ff;
  background: #eaf1ff;
}

.suporte-option__content {
  min-width: 0;
}

.suporte-option h2 {
  margin: 2px 0 8px;
  color: #172033;
  font-size: 1rem;
  font-weight: 700;
}

.suporte-option p {
  min-height: 48px;
  margin: 0 0 18px;
  color: #596579;
  font-size: 0.875rem;
  line-height: 1.55;
}

.suporte-option__button {
  display: inline-flex;
  gap: 8px;
  align-items: center;
  padding: 10px 14px;
  color: #ffffff;
  background: #087f5b;
  border-radius: 6px;
  font-size: 0.8125rem;
  font-weight: 700;
  text-decoration: none;
}

.suporte-option__button:hover {
  color: #ffffff;
  background: #066b4c;
}

.suporte-option__detail,
.suporte-option__email {
  display: block;
  margin-top: 10px;
  color: #596579;
  font-size: 0.8125rem;
}

.suporte-option__email {
  color: #0056ff;
  font-weight: 700;
  text-decoration: underline;
  overflow-wrap: anywhere;
}

@media (max-width: 700px) {
  .suporte-options {
    grid-template-columns: 1fr;
  }

  .suporte-option {
    min-height: auto;
  }
}
</style>